import { Donor } from './donor';
import { Recipient } from './recipient';

export interface Center {
  id: string;
  name: string;
  oimName?: string;
  fullName?: string;
  scoring?: number;
  MaxABOIncompatibleTransplants?: number;
  MaxHLAIncompatibleTransplants?: number;
  MaxABOAndHLAIncompatibleTransplants?: number;
  recipients?: Recipient[];
  donors?: Donor[];
}
export enum CenterCode {
  Amsterdam = 'NAMTP',
  Leiden = 'NLBTP',
  Utrecht = 'NUTTP',
  Rotterdam = 'NRDTP',
  Nijmegen = 'NNYTP',
  Maastricht = 'NMSTP',
  Groningen = 'NGRTP'
}

export const CenterData: Record<CenterCode, { name: string; fullName: string }> = {
  [CenterCode.Amsterdam]: { name: 'Amsterdam', fullName: 'amsterdam_universitair_mc' },
  [CenterCode.Leiden]: { name: 'Leiden', fullName: 'leiden_universitair_mc' },
  [CenterCode.Utrecht]: { name: 'Utrecht', fullName: 'utrecht_universitair_mc' },
  [CenterCode.Rotterdam]: { name: 'Rotterdam', fullName: 'erasmus_mc_umc_rotterdam' },
  [CenterCode.Nijmegen]: { name: 'Nijmegen', fullName: 'radboudumc' },
  [CenterCode.Maastricht]: { name: 'Maastricht', fullName: 'maastricht_universitair_mc' },
  [CenterCode.Groningen]: { name: 'Groningen', fullName: 'groningen_universitair_mc' }
};
